import { render } from "./ExpertMod.vue?vue&type=template&id=aefbf6fe&scoped=true"
import script from "./ExpertMod.vue?vue&type=script&lang=js"
export * from "./ExpertMod.vue?vue&type=script&lang=js"

import "./ExpertMod.vue?vue&type=style&index=0&id=aefbf6fe&lang=scss&scoped=scoped"
import "./ExpertMod.vue?vue&type=style&index=1&id=aefbf6fe&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefbf6fe"]])

export default __exports__